import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";

import * as projectReducer from "containers/Project/reducer";
import * as runReducer from "containers/Run/reducer";
import * as setupReducer from "containers/Setup/reducer";

import ModelList from "components/Business/ModelList/ModelList";

class ModelListContainer extends React.PureComponent {
  render() {
    return <ModelList {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = ownProps.id;

  const optimized = ownProps.optimized;

  const runId = optimized && optimized.innerId !== undefined ? optimized.innerId : id;

  return {
    updateDrilldownValue: (runId, value) => dispatch(projectReducer.updateDrilldownValue(id, runId, value)),
    updateSelectedModel: (model) => dispatch(runReducer.updateFeatureSelection(runId, model, true)),
    updateModelFeedback: (runId, modelId, isLiked) =>
      dispatch(projectReducer.updateModelFeedback(runId, modelId, isLiked))
  };
};

const mapStateToProps = (state, ownProps) => {
  const id = ownProps.id;

  let optimized = ownProps.optimized;
  if (!optimized || Number(optimized.id) !== Number(id)) {
    optimized = projectReducer.getOptimized(state, id);
  }

  const runId = optimized && optimized.innerId !== undefined ? optimized.innerId : id;

  const revenueLabel = setupReducer.getAdvancedRevenueLabel(state, runId);
  const profitLabel = setupReducer.getNetImpactLabel(state, runId);
  const costLabel = setupReducer.getAdvancedCostLabel(state, runId);

  return {
    id: id,
    runId: runId,
    modelGroups: projectReducer.getModelGroups(state, id, true),
    revenueLabel,
    profitLabel,
    costLabel,
    optimized,
    frontierModels: runReducer.getFrontierList(state, ownProps.runId)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(ModelListContainer);
